import { TPartnerStatus } from 'legacy/lut/classes/models/partner360/IFormPartnerBasicInfo'
import { FC, useMemo } from 'react'

import { PartnerFlags } from 'partner360/components/partnerFlags/PartnerFlags'

import { TRANSLATION_KEYS } from '../../translations'
import { AmplifyTrack } from '../partnerFields/amplifyTrack/AmplifyTrack'

import styles from './BasicInfoHeader.module.scss'

interface IBasicInfoHeaderProps {
  isRetailProgramType: boolean
  isDistributor: boolean
  isPowerElite: boolean
  isPowerEliteGlobal: boolean
  amplifyTrack: string
  p360Grades?: TPartnerStatus[]
  specializations?: TPartnerStatus[]
  programs?: TPartnerStatus[]
}

export const BasicInfoHeader: FC<IBasicInfoHeaderProps> = ({
  isRetailProgramType,
  isDistributor,
  isPowerElite,
  isPowerEliteGlobal,
  amplifyTrack,
  p360Grades,
  specializations,
  programs,
}) => {
  const shouldShowSpecializations = useMemo(() => {
    if (!isDistributor) {
      return true
    }

    return specializations?.length ? specializations?.length > 0 : false
  }, [isDistributor, specializations])

  const shouldShowPrograms = useMemo(() => {
    if (!isDistributor) {
      return true
    }

    return programs?.length ? programs?.length > 0 : false
  }, [isDistributor, programs])

  return (
    <>
      <div className={styles.row}>
        <div className={styles.amplifyTrack}>
          <AmplifyTrack
            isRetail={isRetailProgramType}
            isDistributor={isDistributor}
            amplifyTrackValue={amplifyTrack}
            isPowerElite={isPowerElite}
            isPowerEliteGlobal={isPowerEliteGlobal}
          />
        </div>
        <div className={styles.p360Grades}>
          <PartnerFlags
            items={p360Grades}
            labelTranslationKey={TRANSLATION_KEYS.gradesLabel}
            emptyItemsTranslationKey={TRANSLATION_KEYS.emptyGradesLabel}
            classes={{ partnerStatusStyles: styles.flag }}
          />
        </div>
      </div>
      {shouldShowSpecializations && shouldShowPrograms && (
        <div className={styles.row}>
          <div className={styles.specializations}>
            <PartnerFlags
              items={specializations}
              labelTranslationKey={TRANSLATION_KEYS.specializationsLabel}
              emptyItemsTranslationKey={TRANSLATION_KEYS.emptySpecializationsLabel}
            />
          </div>

          <div className={styles.programs}>
            <PartnerFlags
              items={programs}
              labelTranslationKey={TRANSLATION_KEYS.programsLabel}
              emptyItemsTranslationKey={TRANSLATION_KEYS.emptyProgramsLabel}
            />
          </div>
        </div>
      )}
    </>
  )
}
